import React, { useState } from "react";

// Components
import MuiLoader from "../../components/MuiLoader";

// Thunks
import {
  getallmodules,
  getallsubmodules,
  getalltopics,
  getalldata,
  updateassignmentquestion,
} from "./UserAssignment.Thunk";

// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TaskIcon from "@mui/icons-material/Task";
import { indigo } from "@mui/material/colors";

// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// swal
import Swal from "sweetalert2";

function PptAssignmentPage() {
  const theme = useTheme();

  // -------------- Loader --------------------------
  const [loading, setLoading] = useState(false);
  // ------------------------------------------------

  // ------------ Grid gallery view -----------------
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ------------------------------------------------

  // -------------- Card-item vertical menu ---------
  const ITEM_HEIGHT = 48;
  const [selectedData, setSelectedData] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, data) => {
    setAnchorEl(event.currentTarget);
    setSelectedData(data);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedData({});
  };
  // -------------------------------------------------

  // --------- options for dropdowns -----------------
  const usertype_select_option_list = [
    { value: "fellow", text: "Fellow" },
    { value: "school", text: "School" },
    { value: "anganwadi", text: "Anganwadi" },
  ];
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  // -------------------------------------------------

  // ------------ dropdowns on change ----------------
  const selectedTrainingtype = "ppt";
  const [selectedUsertype, setSelectedUsertype] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedSubmodule, setSelectedSubmodule] = useState("");
  const [selectedTopic, setSelectedTopic] = useState("");

  const [moduleData, setModuleData] = useState([]);
  const [submoduleData, setSubmoduleData] = useState([]);
  const [topicData, setTopicData] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [disableCreateButton, setDisableCreateButton] = useState(true);

  const usertype_select_onchange = (event) => {
    setSelectedUsertype(event.target.value);

    setSelectedLanguage("");
    setSelectedModule("");
    setModuleData([]);
    setSelectedSubmodule("");
    setSubmoduleData([]);
    setSelectedTopic("");
    setTopicData([]);
    setDisplayData([]);
    setDisableCreateButton(true);
  };
  const preflanguage_select_onchange = async (event) => {
    setSelectedLanguage(event.target.value);

    setSelectedModule("");
    setModuleData([]);
    setSelectedSubmodule("");
    setSubmoduleData([]);
    setSelectedTopic("");
    setTopicData([]);
    setDisplayData([]);
    setDisableCreateButton(true);
    if (event.target.value !== "") {
      const params = {
        selectedTrainingtype,
        selectedUsertype,
        selectedLanguage: event.target.value,
      };
      setLoading(true);
      const module_data = await getallmodules(params);
      setLoading(false);
      setModuleData(module_data);
    }
  };
  const module_select_onchange = async (event) => {
    setSelectedModule(event.target.value);

    setSelectedSubmodule("");
    setSubmoduleData([]);
    setSelectedTopic("");
    setTopicData([]);
    setDisplayData([]);
    setDisableCreateButton(true);
    if (event.target.value !== "") {
      const params = {
        selectedTrainingtype,
        selectedUsertype,
        selectedLanguage,
        selectedModule: event.target.value,
      };
      setLoading(true);
      const submodule_data = await getallsubmodules(params);
      setLoading(false);
      setSubmoduleData(submodule_data);
    }
  };

  const submodule_select_onchange = async (event) => {
    setSelectedSubmodule(event.target.value);

    setSelectedTopic("");
    setTopicData([]);
    setDisplayData([]);
    setDisableCreateButton(true);

    if (event.target.value !== "") {
      const params = {
        selectedTrainingtype,
        selectedUsertype,
        selectedLanguage,
        selectedModule,
        selectedSubmodule: event.target.value,
      };
      setLoading(true);
      const topic_data = await getalltopics(params);
      setLoading(false);
      setTopicData(topic_data);
    }
  };
  const topic_select_onchange = async (event, value) => {
    setSelectedTopic(event.target.value);

    setDisplayData([]);
    if (event.target.value === "") setDisableCreateButton(true);
    else {
      setDisableCreateButton(false);

      const params = {
        selectedUsertype,
        selectedTrainingtype,
        selectedModule,
        selectedSubmodule,
        selectedTopic: event.target.value,
      };
      setLoading(true);
      const display_data = await getalldata(params);
      setLoading(false);
      setDisplayData(display_data);
    }
  };
  // -------------------------------------------------

  // ----------- create, update delete button click ----------
  const create_button_click = () => {
    //console.log("create displayData: ", displayData);
    if (displayData.length > 1) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Can not create new assignment question. There are multiple assignment questions found. Kindly remove them to create a new one.",
        //footer: '<a href="">Why do I have this issue?</a>',
      });
    } else if (displayData.length === 1) {
      //console.log("create displayData: ", displayData[0].assignmentQuestion);
      if (
        displayData[0].assignmentQuestion &&
        displayData[0].assignmentQuestion.length > 0
      ) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          html: "Can not create new assignment question. <br />There are multiple assignment questions found. <br />Kindly remove them to create a new one.",
          //footer: '<a href="">Why do I have this issue?</a>',
        });
      } else {
        Swal.fire({
          title: "CREATE NEW ASSIGNMENT",
          input: "text",
          inputValue: "",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          confirmButtonText: "Save",
          showLoaderOnConfirm: true,
          preConfirm: async (input_value) => {
            if (
              input_value === undefined ||
              input_value === null ||
              input_value.length <= 0
            )
              toast.error("Enter a valid assignment");
            else {
              setLoading(true);
              const params1 = {
                usertype: displayData[0].usertype,
                trainingtype: displayData[0].trainingType,
                topicid: displayData[0].topicid,
                assignmentQuestion: input_value,
              };

              await updateassignmentquestion(params1); //
              const params2 = {
                selectedUsertype,
                selectedTrainingtype,
                selectedModule,
                selectedSubmodule,
                selectedTopic,
              };
              const display_data = await getalldata(params2);
              setLoading(false);
              setDisplayData(display_data);
              toast.success("Assignment saved successfully"); //
            }
          },
        });
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong. Please try again later.",
      });
    }
  };

  const update_button_click = (data) => {
    handleVertMenuClose();
    if (Object.keys(data).length > 0) {
      const assignmentQuestion_old = data.assignmentQuestion;

      Swal.fire({
        title: "UPDATE ASSIGNMENT",
        input: "text",
        inputValue: assignmentQuestion_old,
        inputAttributes: {
          autocapitalize: "off",
        },
        showCancelButton: true,
        confirmButtonText: "Update",
        showLoaderOnConfirm: true,
        preConfirm: async (input_value) => {
          if (
            input_value === undefined ||
            input_value === null ||
            input_value.length <= 0
          )
            toast.error("Enter a valid assignment");
          else {
            setLoading(true);
            const params1 = {
              usertype: data.usertype,
              trainingtype: data.trainingType,
              topicid: data.topicid,
              assignmentQuestion: input_value,
            };
            await updateassignmentquestion(params1);
            const params2 = {
              selectedUsertype,
              selectedTrainingtype,
              selectedModule,
              selectedSubmodule,
              selectedTopic,
            };
            const display_data = await getalldata(params2);
            setLoading(false);
            setDisplayData(display_data);
            toast.success("Assignment updated successfully");
          }
        },
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong. Please try again later.",
      });
    }
  };

  const delete_button_click = (data) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Are you sure, you want to remove this assignment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const params1 = {
          usertype: data.usertype,
          trainingtype: data.trainingType,
          topicid: data.topicid,
          assignmentQuestion: "",
        };
        await updateassignmentquestion(params1);
        const params2 = {
          selectedUsertype,
          selectedTrainingtype,
          selectedModule,
          selectedSubmodule,
          selectedTopic,
        };
        const display_data = await getalldata(params2);
        setLoading(false);
        setDisplayData(display_data);
        toast.success("Assignment deleted successfully");
      }
    });
  };
  // ---------------------------------------------

  return (
    <>
      <div>
        PPT
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="usertype_select">User type</InputLabel>
          <Select
            labelId="usertype_select"
            id="usertype_select"
            value={selectedUsertype}
            label="User type"
            onChange={usertype_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {usertype_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="language_select">Language</InputLabel>
          <Select
            labelId="language_select"
            id="language_select"
            value={selectedLanguage}
            label="Language"
            onChange={preflanguage_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="module_select">Module</InputLabel>
          <Select
            labelId="module_select"
            id="module_select"
            value={selectedModule}
            label="Module"
            onChange={module_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {moduleData.map((option) => (
              <MenuItem key={option.moduleid} value={option.moduleid}>
                {option.modulename}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="submodule_select">Sub module</InputLabel>
          <Select
            labelId="submodule_select"
            id="submodule_select"
            value={selectedSubmodule}
            label="Sub module"
            onChange={submodule_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {submoduleData.map((option) => (
              <MenuItem key={option.submoduleid} value={option.submoduleid}>
                {option.submodulename}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
          <InputLabel id="topic_select">Topic</InputLabel>
          <Select
            labelId="topic_select"
            id="topic_select"
            value={selectedTopic}
            label="Topic"
            onChange={topic_select_onchange}
          >
            <MenuItem value="">None</MenuItem>
            {topicData.map((option) => (
              <MenuItem key={option.topicid} value={option.topicid}>
                {option.topicname}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          onClick={create_button_click}
          variant="contained"
          disabled={disableCreateButton}
        >
          Create New Assignment Question
        </Button>
      </div>

      {/* Show List */}
      <div>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            {displayData.map((data, index) => {
              if (data.assignmentQuestion && data.assignmentQuestion.length > 0)
                return (
                  <Grid
                    item
                    xs={12}
                    sm={isSmallScreen ? 12 : 6}
                    md={4}
                    key={index}
                  >
                    <Card sx={{ maxWidth: 345 }}>
                      <CardHeader
                        avatar={
                          <Avatar sx={{ bgcolor: indigo[900] }}>
                            <TaskIcon />
                          </Avatar>
                        }
                        action={
                          <>
                            <IconButton
                              id={index + 1.1}
                              onClick={(e) => handleVertMenuClick(e, data)}
                              aria-controls={
                                openVertMenu ? { index } : undefined
                              }
                              aria-expanded={openVertMenu ? "true" : undefined}
                              aria-haspopup="true"
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </>
                        }
                        title={
                          <div
                            style={{
                              cursor: "pointer",
                              wordBreak: "break-all",
                            }}
                          >
                            {data.assignmentQuestion}
                          </div>
                        }
                      />
                    </Card>
                  </Grid>
                );
              else return "";
            })}
            <Menu
              anchorEl={anchorEl}
              open={openVertMenu}
              onClose={handleVertMenuClose}
              MenuListProps={{
                "aria-labelledby": "vert-button",
              }}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                },
              }}
            >
              <MenuItem onClick={() => update_button_click(selectedData)}>
                Edit
              </MenuItem>
              <MenuItem onClick={() => delete_button_click(selectedData)}>
                Delete
              </MenuItem>
            </Menu>
          </Grid>
        </Box>
      </div>

      {/* Loader */}
      <MuiLoader open={loading} />

      {/* Toaster */}
      <ToastContainer />
    </>
  );
}

export default PptAssignmentPage;
